import { render, staticRenderFns } from "./ItsBaseCarrier.vue?vue&type=template&id=9c448ff6&scoped=true&"
import script from "./ItsBaseCarrier.vue?vue&type=script&lang=js&"
export * from "./ItsBaseCarrier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c448ff6",
  null
  
)

export default component.exports